import './App.css';
import NavBarLayout from './NavbarLayout';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { buttonStyle } from './colors';

function OutfitMethods() {
  const navigate = useNavigate();

  return (
    <NavBarLayout title="Make my #OOTD" onBackButtonClicked={() => navigate("/home")} active={0}>
      <div className="OutfitMethods-container">
        <Button onClick={() => navigate("/autogenerate")} sx={{fontSize: 20, ...buttonStyle}} variant="contained">Automatically generate my #OOTD</Button>
        <Button onClick={() => navigate("/manualoutfit")} sx={{fontSize: 20, ...buttonStyle}} variant="contained">Manually choose my #OOTD</Button>
      </div>
    </NavBarLayout>
  );
}

export default OutfitMethods;
